<p-panel header="{{'I18nValue.additionalData' | hisUi}}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<!-- check if publicationType is not null -->
	<div *ngIf="publication.publicationType">
		<!-- Zeitschrift -->
		<res-journal-plam
			[(selectedJournal)]="publication.journal"
			[publication]="publication"
            [childPublication]="childPublication"
			[dDKey]="getDdKey('journal')"
			(navigationLastUrlChange)="onNavigationLastUrlChange($event)">
		</res-journal-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('journal')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- Blogbeitrag -->
		<his-plam>
			<input #content [(ngModel)]="publication.blogName" pInputTexst class="inputWidth100" [hisDdKey]="getDdKey('blogName')">
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('blogName')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>
		<!-- Übergeordnete Publikation -->
        <res-publication-parent-plam
            *ngIf="publicationTypeChildParentMap && publicationTypeChildParentMap[publication.publicationType.id]"
            [publicationTypeChildParentMap]="publicationTypeChildParentMap"
            [(selectedParent)]="publication.parent"
            (navigateToCreateParentOnNextSave)="navigateToCreateParentOnNextSave.emit($event)"
            (navigateToEditParentOnNextSave)="navigateToEditParentOnNextSave.emit($event)"
            [publication]="publication"
            [dDKey]="getDdKey('parent')">
        </res-publication-parent-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('parent')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Konferenz -->
        <res-conference-plam
            [(selectedConference)]="publication.conference"
            [publication]="publication"
            [childPublication]="childPublication"
            [dDKey]="getDdKey('conference')"
            (navigationLastUrlChange)="onNavigationLastUrlChange($event)">
        </res-conference-plam>
        <ng-container *ngIf="getIsDynamicContainerVisible('conference')">
            <!-- #anchor dynamic field container -->
            <ng-template #dynamicFieldContainer></ng-template>
        </ng-container>

		<!-- Verlag -->
		<res-publisher-plam
			[(publisher)]="publication.publisher"
			[publication]="publication"
            [childPublication]="childPublication"
			[dDKey]="getDdKey('publisher')"
			(navigationLastUrlChange)="onNavigationLastUrlChange($event)">
		</res-publisher-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('publisher')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- Auflage -->
		<his-plam>
			<input #content [(ngModel)]="publication.edition" pInputText class="inputWidth100" [hisDdKey]="getDdKey('edition')">
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('edition')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- Band -->
		<ng-container *ngIf="isHidden('parent') || !(publication.parent)">
			<his-plam>
				<input #content [(ngModel)]="publication.volume" pInputText class="inputWidth100" [hisDdKey]="getDdKey('volume')">
			</his-plam>
			<ng-container *ngIf="getIsDynamicContainerVisible('volume')">
				<!-- #anchor dynamic field container -->
				<ng-template #dynamicFieldContainer></ng-template>
			</ng-container>
		</ng-container>

		<!-- Heft -->
		<ng-container *ngIf="isHidden('parent') || !(publication.parent)">
			<his-plam>
				<input #content [(ngModel)]="publication.issue" pInputText class="inputWidth100" [hisDdKey]="getDdKey('issue')">
			</his-plam>
			<ng-container *ngIf="getIsDynamicContainerVisible('issue')">
				<!-- #anchor dynamic field container -->
				<ng-template #dynamicFieldContainer></ng-template>
			</ng-container>
		</ng-container>

        <!-- Artikelnummer -->
        <his-plam>
			<input #content [(ngModel)]="publication.articleNumber" pInputText class="inputWidth100" [hisDdKey]="getDdKey('articleNumber')">
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('articleNumber')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- Seitenbereich -->
        <his-plam>
            <input #content class="inputWidth100" [maxlength]="18" [(ngModel)]="publication.pageRangeFrom" pInputText [hisDdKey]="getDdKey('pageRangeFrom')" (blur)="calculateNumberOfPages(true); checkNumberOfPages();">
        </his-plam>
        <ng-container *ngIf="getIsDynamicContainerVisible('pageRangeFrom')">
            <!-- #anchor dynamic field container -->
            <ng-template #dynamicFieldContainer></ng-template>
        </ng-container>
        <his-plam>
            <input #content class="inputWidth100" [maxlength]="18" [(ngModel)]="publication.pageRangeTo" pInputText [hisDdKey]="getDdKey('pageRangeTo')" (blur)="calculateNumberOfPages(true); checkNumberOfPages();">
        </his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('pageRangeTo')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Seitenanzahl -->
        <ng-container *ngIf="!isPublicationTypeBook" [ngTemplateOutlet]="numberOfPagesTemplate"></ng-container>

		<!-- Serie -->
		<ng-container *ngIf="(isHidden('parent') || !publication.parent) && (isHidden('journal') || !publication.journal)">
			<his-plam>
				<input #content [(ngModel)]="publication.series" pInputText class="inputWidth100" [hisDdKey]="getDdKey('series')">
			</his-plam>
			<ng-container *ngIf="getIsDynamicContainerVisible('series')">
				<!-- #anchor dynamic field container -->
				<ng-template #dynamicFieldContainer></ng-template>
			</ng-container>
		</ng-container>

		<!-- Serienzählung -->
		<ng-container *ngIf="(isHidden('parent') || !publication.parent) && (isHidden('journal') || !publication.journal)">
			<his-plam>
				<input #content [(ngModel)]="publication.numberInSeries" pInputText class="inputWidth100" [hisDdKey]="getDdKey('numberInSeries')">
			</his-plam>
			<ng-container *ngIf="getIsDynamicContainerVisible('numberInSeries')">
				<!-- #anchor dynamic field container -->
				<ng-template #dynamicFieldContainer></ng-template>
			</ng-container>
		</ng-container>

		<!-- Typ der Ressource -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('publicationResourceType')"
				[(ngModel)]="publication.publicationResourceType" hisEagerDataSource="publicationResourceTypeValue"
				(onClear)="onClear('publicationResourceType')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('publicationResourceType')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Seitenanzahl -->
        <ng-container *ngIf="isPublicationTypeBook" [ngTemplateOutlet]="numberOfPagesTemplate"></ng-container>

		<!-- Darstellungsform -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('publicationResource')"
				[(ngModel)]="publication.publicationResource" hisEagerDataSource="publicationResourceValue"
				(onClear)="onClear('publicationResource')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('publicationResource')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- peer-reviewed -->
		<his-plam>
            <p-autoComplete #content [hisDdKey]="getDdKey('peerReviewedProcess')"
                    [(ngModel)]="publication.peerReviewedProcess" hisEagerDataSource="peerReviewedValue"
                    (onClear)="onClear('peerReviewedProcess')">
            </p-autoComplete>
        </his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('peerReviewed')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

		<!-- Art der Qualifikationsschrift -->
		<his-plam>
			<p-autoComplete #content [hisDdKey]="getDdKey('qualificationThesis')"
				[(ngModel)]="publication.qualificationThesis" hisEagerDataSource="qualificationThesisValue"
				(onClear)="onClear('qualificationThesis')">
			</p-autoComplete>
		</his-plam>
		<ng-container *ngIf="getIsDynamicContainerVisible('qualificationThesis')">
			<!-- #anchor dynamic field container -->
			<ng-template #dynamicFieldContainer></ng-template>
		</ng-container>

        <!-- Seitenanzahl Template -->
        <ng-template #numberOfPagesTemplate>
            <his-plam>
                <p-inputNumber #content [hisDdKey]="getDdKey('numberOfPages')" styleClass="fullWidth" class="fullWidth"
                    [(ngModel)]="publication.numberOfPages" (onBlur)="checkNumberOfPages()" [maxlength]="11">
                </p-inputNumber>
            </his-plam>
            <ng-container *ngIf="getIsDynamicContainerVisible('numberOfPages')">
                <!-- #anchor dynamic field container -->
                <ng-template #dynamicFieldContainer></ng-template>
            </ng-container>
        </ng-template>
	</div>

	<!-- Schlagwörter -->
	<ng-container *ngIf="hisBaseGlobalsService.isAnyModuleActive('HISINONERES')">
		<his-plam *ngIf="!keyWordsFieldConfig">
	 		<p-chips #content hisDdKey="fs.res.publication.Publication.keywords"
	 			[(chips)]="publication.keyWords" [allowDuplicate]="false" [addOnBlur]="true">
	 		</p-chips>
		</his-plam>
        <his-dynamicfield *ngIf="keyWordsFieldConfig" [form]="changeRequesForm" [valueGroup]="changeRequestValueGroup" [dynamicFieldConfig]="keyWordsFieldConfig"></his-dynamicfield>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>
	</ng-container>

	<!-- Kommentar -->
	<ng-container *ngIf="auth.hasAny('RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_COMMENT')">
		<his-plam>
			<textarea #content [(ngModel)]="publication.commentary" class="textareaWidth100" hisDdKey="fs.res.publication.Publication.commentary" rows="2"></textarea>
		</his-plam>

		<!-- #anchor dynamic field container -->
		<ng-template #dynamicFieldContainer></ng-template>
	</ng-container>

</p-panel>
